<template>
<div>
    <plant-variety-status-list></plant-variety-status-list>
</div>
</template>

<script>
export default {}
</script>
